<template>
   <div >
        <div class="nse mb-3 text-center">
            <fieldset class="dhhBorder">
                <legend class="dhhBorder">Negocios</legend>
                <img :src="getImage('company.svg')" width="100" height="100" class="mb-3 mt-2" data-toggle="tooltip" data-placement="right" title="Negocios">
                <h4>{{countNegocio}}</h4>
            </fieldset>
        </div>

        <div class="row text-center justify-content-around">
            <div class="col-md-6 col-sm-12">
                <fieldset class="dhhBorder">
                    <legend class="dhhBorder">Operaciones (años)</legend>
                    <div id="operationscharts"></div>
                </fieldset>
            </div>

            <div class="col-md-6 col-sm-12">
                <fieldset class="dhhBorder">
                    <legend class="dhhBorder">Personal (trabajadores)</legend>
                    <div id="personalcharts"></div>
                </fieldset>
            </div>
        </div>
    
        <!-- <div class="row mt-3">
            <div class="col-md-4">
                <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                    <a class="nav-link group active" id="pills-home-tab" data-toggle="pill" href="#Restaurantes"
                    role="tab" aria-controls="pills-home" aria-selected="true">Restaurantes</a>
                    <a class="nav-link group" id="pills-profile-tab" data-toggle="pill" href="#Financieras"
                    role="tab" aria-controls="pills-profile" aria-selected="false">Financieras</a>
                    <a class="nav-link group" id="pills-contact-tab" data-toggle="pill" href="#Bodegas"
                    role="tab" aria-controls="pills-contact" aria-selected="false">Bodegas</a>
                    <a class="nav-link group" id="pills-contact-tab" data-toggle="pill" href="#Otras"
                    role="tab" aria-controls="pills-contact" aria-selected="false">Otras</a>
                </div>
            </div>

            <div class="col-md-8">
                <div class="tab-content" id="v-pills-tabContent">
                    <div class="tab-pane groups fade show active" id="Restaurantes" role="tabpanel" aria-labelledby="pills-home-tab">
                        1
                        <div class="table-responsive tables">
                            <table class="table table-sm table-bordered" style="width:100%" id="rubros"></table>                            
                        </div>
                    </div>

                    <div class="tab-pane groups fade" id="Financieras" role="tabpanel" aria-labelledby="pills-profile-tab">
                        1
                    </div>

                    <div class="tab-pane groups fade" id="Bodegas" role="tabpanel" aria-labelledby="pills-contact-tab">
                        1
                    </div>

                    <div class="tab-pane groups fade" id="Otras" role="tabpanel" aria-labelledby="pills-contact-tab">
                        1
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
    export default {
        props: [
            'data'
        ],
        data() {
            return {
                result:{}
            };
        },
        watch:{
            data() {
                this.openBusiness();
            }
        },
        computed: {
            countNegocio() {
                var count = (this.result.anios_0_2 + this.result.anios_3_5 + this.result.anios_6).toLocaleString();

                return count;
            }
        },
        methods: {
            openBusiness() {
                var comp = this;
                comp.result = this.data;

                AmCharts.makeChart( "operationscharts", {
                    "hideCredits":true,
                    "type": "pie",
                    "balloonText": "<span style='font-size:12px'><b>[[title]]:</b><br><b>[[value]]</b> </span>",
                    "innerRadius": 12,
                    "labelRadius": -25,
                    "labelText": "[[percents]]%",
                    "percentPrecision": 1,
                    "hideLabelsPercent": 10,
                    "radius": 60,
                    "fontSize": 9,
                    "color": "#000000",
                    "titleField": "title",
                    "valueField": "value",
                    "allLabels": [],
                    "balloon": {},
                    "pieX": '32%',
                    "legend": {
                        "enabled": true,
                        "align": "left",
                        "labelText": "[[title]]",
                        "position": "absolute",
                        "valueText": "",
                        "fontSize": 9,
                        "markerSize": 7,
                        "autoMargins": false,
                        "maxColumns": 1,
                        "left": 150,
                        "top": 25
                    },
                    "titles": [],
                    "dataProvider": [ {
                        "title": "0-2",
                        "value": comp.result.anios_0_2
                    }, {
                        "title": "3-5",
                        "value": comp.result.anios_3_5
                    }, {
                        "title": "6 a más",
                        "value": comp.result.anios_6
                    }]
                });

                AmCharts.makeChart( "personalcharts", {
                    "hideCredits":true,
                    "type": "pie",
                    "balloonText": "<span style='font-size:12px'><b>[[title]]:</b><br><b>[[value]]</b> </span>",
                    "innerRadius": 12,
                    "labelRadius": -25,
                    "labelText": "[[percents]]%",
                    "percentPrecision": 1,
                    "hideLabelsPercent": 10,
                    "radius": 60,
                    "fontSize": 9,
                    "color": "#000000",
                    "titleField": "title",
                    "valueField": "value",
                    "allLabels": [],
                    "balloon": {},
                    "pieX": '32%',
                    "legend": {
                        "enabled": true,
                        "align": "left",
                        "labelText": "[[title]]",
                        "position": "absolute",
                        "valueText": "",
                        "fontSize": 9,
                        "markerSize": 7,
                        "autoMargins": false,
                        "maxColumns": 1,
                        "left": 150,
                        "top": 5
                    },
                    "titles": [],
                    "dataProvider": [ {
                        "title": "0",
                        "value": comp.result.trabajadores_0
                    }, {
                        "title": "1-10",
                        "value": comp.result.trabajadores_1_10
                    }, {
                        "title": "11-100",
                        "value": comp.result.trabajadores_11_100
                    }, {
                        "title": "101-500",
                        "value": comp.result.trabajadores_101_500
                    }, {
                        "title": "501 a más",
                        "value": comp.result.trabajadores_501
                    }]
                });
            },
            getImage(val) {
                return require('@/assets/images/dataquality/business/' + val);
            }
        }
    }
</script>

<style scoped>
    .group {
        font-size: 12px;
    }
    .group.active {
        color: #007bff !important;
        border: 1px solid #007bff;
        background-color: transparent !important;
    }
    .groups.active {
        background-color: transparent !important;
    }
    #operationscharts {
        margin: 0px 0px 0px 15px;
        width: 86%;
        height: 150px;
        font-size: 10px;
    }
    #personalcharts{
        margin: 0px 15px;
        width: 86%;
        height: 150px;
        font-size: 10px;
    }
    fieldset.dhhBorder {
        border: 1px solid #eee;
        margin: 0 0 15px 0;
        box-shadow: 0 6px 10px rgba(0,0,0,0.2);
        border-radius: 5px;
    }
    legend.dhhBorder {
        font-size: 13px;
        color:#2164f9;
        text-align: left;
        width: auto;
        padding: 0px;
        border-bottom: none;
        margin: 0px;
        text-transform: capitalize;
    }
    @media (min-width: 768px){
        .negocios{
            margin-left: -120px;
        }
    }
</style>
